import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { router } from '@/router'
import { queryClient } from '@/lib/api/queryClient'
import { bootstrapSession, usingMockAuth } from '@/lib/auth/authClient'
import { setActiveWorldConfig } from '@gamecodex/world-config'
import { pixenIntrigueWorldConfig } from './world.config'
import './index.css'

// Register the active world before anything renders. The shared shell reads
// world-specific facets + entitlement policy from this config.
setActiveWorldConfig(pixenIntrigueWorldConfig)

if (!usingMockAuth) void bootstrapSession()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
)
